import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import '@src/css/global.scss';

/**
 * ## CardRowContainer
 *
 * Container for card-deck rows
 * @param {object} CardRowContainer Redux training courses data
 */

export const CardRowContainer = (props) => {
    const { children } = props;

    return (
        <Row className="main-container-row">
            <Col sm={12}>
                <Row>
                    {children}
                </Row>
            </Col>
        </Row>
    );
};

CardRowContainer.propTypes = {
    children: PropTypes.node,
};

export default CardRowContainer;
